import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6734713d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card p-4 mb-4" }
const _hoisted_2 = { class: "row g-3 align-items-end" }
const _hoisted_3 = { class: "col-md-2 col-sm-6" }
const _hoisted_4 = { class: "form-label fs-7 fw-semibold" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "col-md-2 col-sm-6" }
const _hoisted_7 = { class: "form-label fs-7 fw-semibold" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "col-md-2 col-sm-6" }
const _hoisted_10 = { class: "form-label fs-7 fw-semibold" }
const _hoisted_11 = { value: "all" }
const _hoisted_12 = { value: "expired_no_renewal" }
const _hoisted_13 = { value: "active_no_ads_usage" }
const _hoisted_14 = { value: "free_package_only" }
const _hoisted_15 = {
  key: 0,
  class: "col-md-2 col-sm-6"
}
const _hoisted_16 = { class: "form-label fs-7 fw-semibold" }
const _hoisted_17 = { value: "1" }
const _hoisted_18 = { value: "2" }
const _hoisted_19 = { value: "3" }
const _hoisted_20 = { value: "6" }
const _hoisted_21 = { value: "12" }
const _hoisted_22 = {
  key: 1,
  class: "col-md-2 col-sm-6"
}
const _hoisted_23 = { class: "form-label fs-7 fw-semibold" }
const _hoisted_24 = { value: "7" }
const _hoisted_25 = { value: "14" }
const _hoisted_26 = { value: "30" }
const _hoisted_27 = { value: "60" }
const _hoisted_28 = { value: "90" }
const _hoisted_29 = { class: "col-auto" }
const _hoisted_30 = { class: "row g-3 align-items-end" }
const _hoisted_31 = { class: "col-md-auto col-sm-6" }
const _hoisted_32 = { class: "form-label fs-7 fw-semibold d-block" }
const _hoisted_33 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_34 = {
  class: "btn btn-outline-secondary btn-sm",
  for: "memberTypeAll"
}
const _hoisted_35 = {
  class: "btn btn-outline-primary btn-sm",
  for: "memberTypeBroker"
}
const _hoisted_36 = {
  class: "btn btn-outline-success btn-sm",
  for: "memberTypeMarketeer"
}
const _hoisted_37 = { class: "d-flex flex-wrap gap-3 mt-4" }
const _hoisted_38 = { class: "summary-card bg-light-info rounded p-2 flex-grow-1" }
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = { class: "svg-icon svg-icon-1 svg-icon-info me-2" }
const _hoisted_41 = { class: "fs-7 text-gray-600" }
const _hoisted_42 = { class: "fs-5 fw-bold text-info" }
const _hoisted_43 = { class: "summary-card bg-light-primary rounded p-2 flex-grow-1" }
const _hoisted_44 = { class: "d-flex align-items-center" }
const _hoisted_45 = { class: "svg-icon svg-icon-2x svg-icon-primary me-2" }
const _hoisted_46 = { class: "fs-7 text-gray-600" }
const _hoisted_47 = { class: "fs-5 fw-bold text-primary" }
const _hoisted_48 = { class: "summary-card bg-light-success rounded p-2 flex-grow-1" }
const _hoisted_49 = { class: "d-flex align-items-center" }
const _hoisted_50 = { class: "svg-icon svg-icon-1 svg-icon-success me-2" }
const _hoisted_51 = { class: "fs-7 text-gray-600" }
const _hoisted_52 = { class: "fs-5 fw-bold text-success" }
const _hoisted_53 = {
  key: 0,
  class: "summary-card bg-light-warning rounded p-3 flex-grow-1"
}
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = { class: "svg-icon svg-icon-1 svg-icon-warning me-2" }
const _hoisted_56 = { class: "fs-7 text-gray-600" }
const _hoisted_57 = { class: "fs-4 fw-bold text-warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.translate('phone')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "phone",
          class: "form-control form-control-sm form-control-solid",
          placeholder: _ctx.translate('phone'),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.phone) = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"]))
        }, null, 40, _hoisted_5), [
          [_vModelText, _ctx.selectedItems.phone]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.translate('email')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "email",
          class: "form-control form-control-sm form-control-solid",
          placeholder: _ctx.translate('email'),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.email) = $event)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"]))
        }, null, 40, _hoisted_8), [
          [_vModelText, _ctx.selectedItems.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.translate('behaviorFilter')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems.behaviorFilter) = $event)),
          class: "form-select form-select-sm form-select-solid",
          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onBehaviorFilterChange && _ctx.onBehaviorFilterChange(...args)))
        }, [
          _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.translate('all')), 1),
          _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.translate('expiredNoRenewal')), 1),
          _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.translate('activeNoAdsUsage')), 1),
          _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.translate('freePackageOnly')), 1)
        ], 544), [
          [_vModelSelect, _ctx.selectedItems.behaviorFilter]
        ])
      ]),
      (_ctx.selectedItems.behaviorFilter.includes('expired_no_renewal'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate('monthsWithoutRenewal')), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedItems.monthsWithoutRenewal) = $event)),
              class: "form-select form-select-sm form-select-solid"
            }, [
              _createElementVNode("option", _hoisted_17, "1 " + _toDisplayString(_ctx.translate('month')), 1),
              _createElementVNode("option", _hoisted_18, "2 " + _toDisplayString(_ctx.translate('months')), 1),
              _createElementVNode("option", _hoisted_19, "3 " + _toDisplayString(_ctx.translate('months')), 1),
              _createElementVNode("option", _hoisted_20, "6 " + _toDisplayString(_ctx.translate('months')), 1),
              _createElementVNode("option", _hoisted_21, "12 " + _toDisplayString(_ctx.translate('months')), 1)
            ], 512), [
              [_vModelSelect, _ctx.selectedItems.monthsWithoutRenewal]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedItems.behaviorFilter.includes('active_no_ads_usage'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('daysWithoutAds')), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedItems.daysWithoutAds) = $event)),
              class: "form-select form-select-sm form-select-solid"
            }, [
              _createElementVNode("option", _hoisted_24, "7 " + _toDisplayString(_ctx.translate('days')), 1),
              _createElementVNode("option", _hoisted_25, "14 " + _toDisplayString(_ctx.translate('days')), 1),
              _createElementVNode("option", _hoisted_26, "30 " + _toDisplayString(_ctx.translate('days')), 1),
              _createElementVNode("option", _hoisted_27, "60 " + _toDisplayString(_ctx.translate('days')), 1),
              _createElementVNode("option", _hoisted_28, "90 " + _toDisplayString(_ctx.translate('days')), 1)
            ], 512), [
              [_vModelSelect, _ctx.selectedItems.daysWithoutAds]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-light me-1",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
        }, _toDisplayString(_ctx.translate('reset')), 1),
        _createElementVNode("button", {
          class: "btn btn-sm btn-primary",
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, _toDisplayString(_ctx.translate('apply')), 1)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate('memberType')), 1),
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "btn-check",
              id: "memberTypeAll",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedItems.memberType) = $event)),
              value: "all"
            }, null, 512), [
              [_vModelRadio, _ctx.selectedItems.memberType]
            ]),
            _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.translate('all')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "btn-check",
              id: "memberTypeBroker",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedItems.memberType) = $event)),
              value: "broker"
            }, null, 512), [
              [_vModelRadio, _ctx.selectedItems.memberType]
            ]),
            _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.translate('broker')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "btn-check",
              id: "memberTypeMarketeer",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedItems.memberType) = $event)),
              value: "marketeer"
            }, null, 512), [
              [_vModelRadio, _ctx.selectedItems.memberType]
            ]),
            _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.translate('marketeer')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("span", _hoisted_40, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/graphs/gra001.svg" })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.translate('total')), 1),
            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.summary.totalCount), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("span", _hoisted_45, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com006.svg" })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.translate('brokers')), 1),
            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.summary.brokersCount), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("span", _hoisted_50, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com014.svg" })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.translate('marketers')), 1),
            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.summary.marketeersCount), 1)
          ])
        ])
      ]),
      (_ctx.summary.filteredCount !== _ctx.summary.totalCount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("span", _hoisted_55, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen031.svg" })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.translate('filteredResults')), 1),
                _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.summary.filteredCount), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}